import { buttonReset } from 'components/Button/Button.styles'
import { Stack } from 'components/Stack'
import { styled } from 'stitches.config'

export const TagsRoot = styled(Stack, {
  marginTop: '$7',
  gap: '$2',
  flexWrap: 'wrap',
})

export const Tag = styled('button', buttonReset, {
  px: '$4',
  py: '4px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$primary-500',
  color: '$primary-500',
  backgroundColor: 'transparent',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '22px',
  cursor: 'pointer',
  width: '144px',

  '@bp2': {
    width: 'auto',
  },

  '&:hover': {
    backgroundColor: '$error-100',
  },

  '&:active': {
    backgroundColor: 'transparent',
  },

  variants: {
    isActive: {
      true: {
        backgroundColor: '$primary-500',
        color: '$accent-white',

        '&:hover': {
          backgroundColor: '$primary-500',
        },
      },
    },
  },
})
